import type { Invoice } from '@coreledger/shared-types';
import { api } from './client';

export interface PaginationMeta { total: number; page: number; limit: number; totalPages: number }
export interface Paginated<T> { data: T[]; meta: PaginationMeta }

export interface InvoiceFilter {
  status?: string;
  docType?: string;
  partyId?: string;
  dateFrom?: string;
  dateTo?: string;
  search?: string;
  excludeLorryReceipts?: boolean;
}

function toQuery(f: InvoiceFilter & { page?: number; limit?: number }): string {
  const p = new URLSearchParams();
  Object.entries(f).forEach(([k, v]) => { if (v !== undefined && v !== '') p.set(k, String(v)); });
  const s = p.toString();
  return s ? `?${s}` : '';
}

export const invoicesApi = {
  list: (filter: InvoiceFilter = {}, page = 1, limit = 50) => api.get<Paginated<Invoice>>(`/invoices${toQuery({ ...filter, page, limit })}`),
  get: (id: string) => api.get<Invoice>(`/invoices/${id}`),
  create: (data: Partial<Invoice>) => api.post<Invoice>('/invoices', data),
  update: (id: string, data: Partial<Invoice>) => api.patch<Invoice>(`/invoices/${id}`, data),
  delete: (id: string) => api.delete<void>(`/invoices/${id}`),
  nextNumber: () => api.get<{ number: string }>('/invoices/next-number'),
  raiseFromLRs: (lrIds: string[]) => api.post<Invoice>('/invoices/raise-from-lrs', { lrIds }),
};
